// const omiseParams = (window as unknown as { omise_params: { key: string } })
//   .omise_params

// export const OMISE_PUBLIC_KEY = omiseParams.key

export const CHECKOUT_URL = '/checkout'
export const SEARCH_PLACEHOLDER = 'What are you looking for?'
export const BACK_TO_TOP_TEXT = 'Back to top'
export const SIGN_UP_NEWSLETTER_TEXT = 'Sign up for email updates'
export const EMAIL_LABEL = 'Email Address'
export const SUBSCRIBE_BUTTON_TEXT = 'Subscribe'
export const LOAD_MORE_OFFSET = 200
